import styled from 'styled-components';

export const StyledBlogPost = styled.article`
  display: 'block';
  width: 100%;
  margin-bottom: ${({ direction }) => direction === 'row' ? '10px' : '20px'};
  padding-left: 20px;
  box-sizing: border-box;

  &:not(:last-of-type) {
    .blog-post {
      ${({ direction, theme }) => direction === 'row' && `
        padding-bottom: 10px;
        border-bottom: 1px solid ${theme.colors.gray};
      `}
    }
  }

  .blog-post {
    display: flex;
    flex-direction: ${({ direction }) => direction};
    flex-wrap: nowrap;

    & a {
      text-decoration: none;
      &:visited {
        color: ${({ theme }) => theme.colors.black};
      }
      &:hover {
        color: ${({theme}) => theme.colors.tycoonMain};
      }
    }

    &_image-link {
      display: inline-block;
      max-width: ${({ direction }) => direction === 'row' ? '40%' : '100%'};

      &__video-image {
        cursor: pointer;
      }

      & * {
        transition: all .3s;
      }

      &_image-container {
        overflow: hidden;
        position: relative;

        &:hover {
          div {
            transform: scale(1.2);
          }
        }

        &_video-icon {
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        &_image-block {
          width: 100%;
          padding-top: 60%;
          background: url(${({ imageUrl }) => imageUrl}) center no-repeat;
          background-origin: border-box;
          background-size: cover;
        }
      }
    }

    &_details-container {
      flex-shrink: 1;
      ${({ direction }) => direction === 'row' && 'padding-left: 1em;'}
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      &_category-container {
        margin: ${({ direction }) => direction === 'row' ? '0' : '.5em 0'};
        display: flex;
        align-items: center;
        font-size: .8em;

        &_category-name {
          margin-left: .3em;
          font-weight: ${({ theme }) => theme.fontWeights[3]};

          &:visited {
            color: ${({ theme }) => theme.colors.black};
          }
        }

        &_post-time {
          font-size: .9em;
          color: ${({ theme }) => theme.colors.darkGray};
        }

        & > i {
          margin: 0 .3em;
        }
      }

      &_text-link {
        display: inline-block;
        & h3 {
          font-size: 1.6em;
          ${({ direction }) => direction === 'row' && 'min-height: 2.6em;'}
          font-weight: ${({ theme }) => theme.fontWeights[4]};
        }

        &:visited {
          color: ${({ theme }) => theme.colors.black};
        }

        &:hover {
          color: ${({ theme }) => theme.colors.tycoonMain};
        }
      }
    }
  }
`;
